const VRInstruction = () => {
    return (
        <div className="gameplay-section">
        <p className="module-title"> VR Installation Guide</p>

        <div className="play-gap">
 
<div className="division">
        <div className="item" id ="shrink-sides">
              <a href="https://webglbucketvideos.s3.me-south-1.amazonaws.com/VR_Install_guide.pdf" target="_blank" rel="noopener noreferrer" className="image-container">
                    <img src="/mainImages/guide/vr_installation.jpg"  alt="Video Instruction" className="game-image"/>
                      <div className="description-box-play" id="color-change">PDF Guide</div>
                  </a>

        </div>

        <div className="item" id ="shrink-sides">
              <a href="https://webglbucketvideos.s3.me-south-1.amazonaws.com/VR_Install_guide.mp4" target="_blank" rel="noopener noreferrer" className="image-container">
                    <img src="/mainImages/guide/vr_installation_video.jpg"  alt="Video Instruction" className="game-image"/>
                      <div className="description-box-play" id="color-change">Video Guide</div>
                  </a>
        </div>

</div>
</div>
      </div>
     
     
    

    );
  };
  
  export default VRInstruction;